import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { images } from "../assets";

import { DialogContextType } from "../../DialogComponents/FullScreenDialog";

export const useContext = (): DialogContextType => {
  const { t } = useTranslation("dialogs");

  return useMemo(
    () => ({
      title: {
        text: t("aggregation.dataAggregation"),
        icon: "tools_aggregation",
      },
      attributes: {
        addAttribute: t("aggregation.addAttribute"),
      },
      help: {
        hintsBlock: {
          title: t("aggregation.hintBlockTitle"),
          hints: [
            {
              img: images.initial,
              label: t("aggregation.infoObjects"),
            },
            {
              icon: "plus",
            },
            {
              img: images.withGeometry,
              label: t("aggregation.noInfoGeometry"),
            },
            {
              icon: "arrow_forward",
            },
            {
              img: images.withIntersect,
              label: t("aggregation.objectsAndGeometry"),
            },
            {
              icon: "pause",
            },
            {
              img: images.result,
              label: t("aggregation.geometryWithInfo"),
            },
          ],
        },
      },
    }),
    [t],
  );
};
